function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1.2 11.8V5.9H0v-2h1.2V2.7c0-1.6.5-2.7 2.2-2.7h2.1v2H4c-.7 0-.9.4-.9 1v1h2.3l-.3 2h-2v5.9H1.2z"
});

var SvgFacebook = function SvgFacebook(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 5.5 11.8"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA1LjUgMTEuOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNS41IDExLjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj4KCQk8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xLjIsMTEuOFY1LjlIMHYtMmgxLjJWMi43QzEuMiwxLjEsMS43LDAsMy40LDBoMi4xdjJINEMzLjMsMiwzLjEsMi40LDMuMSwzdjFoMi4zbC0wLjMsMmgtMnY1LjlIMS4yeiIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgFacebook as ReactComponent };